<template>
  <div id="index">
    <common-header></common-header>
    <h1>!!!ツイッターbotメンテ!!!</h1>
    <v-btn @click="getTwitter">hoge</v-btn>
    <v-tabs fixed-tabs slider-color="red">
      <v-tab @click="onTabClick('latest')">新着</v-tab>
      <v-tab @click="onTabClick('popularity')">人気</v-tab>
    </v-tabs>
    <v-list two-line v-if="records.length>0">
      <template v-for="(r,id) in records">
        <v-layout row wrap :key=id>
          <v-flex md10>
            <v-list-tile :key="id" avatar @click="onRecordClick(r.id)" class="record-wrapper" style="height:85px;">
              <v-list-tile-avatar tile size="70">
                <v-img :src="r.imageUrl" aspect-ratio="1"></v-img>
              </v-list-tile-avatar>
              <!-- <v-list-tile-avatar tile size="50"><img :src="r.imageUrl"></v-list-tile-avatar> -->
              <v-list-tile-content style="height:85px;">
                <v-list-tile-sub-title style="height:36px;">
                  <v-chip v-if="r.coEdit" dark color="red accent-1" small>みんなの年表</v-chip>
                  <strong v-else style="font-size:120%;">{{r.displayName}}</strong>
                  {{r.timestamp | displayDate}}
                  <v-chip v-if="r.coEdit && r.tips_count" dark color="orange" small outline>投稿:{{r.tips_count}}</v-chip>
                </v-list-tile-sub-title>
                <v-list-tile-title v-html="r.title + 'の年表'" class="mincho title"></v-list-tile-title>
                <v-list-tile-sub-title style="height:40px;">
                  <v-chip v-if="r.comment_count>0" small label outline color="red accent-1">
                    <v-icon small>comment</v-icon>&nbsp;{{r.comment_count}}
                  </v-chip>
                  {{r.text | textTrim}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
          <v-flex md2 style="padding-top:10px;"><v-btn color="red" dark fab @click="setTwitter(r)">GO</v-btn></v-flex>
        </v-layout>
      </template>
    </v-list>
    <div v-if="!isLoading" style="width:100%;text-align:center;">
      <v-btn v-if="!isMax" color="red" large dark @click="onMore">もっと見る</v-btn>
    </div>
    <v-flex xs12 v-if="isLoading" style="text-align:center;padding-top: 40px;margin: 100px 0;">
      <v-progress-circular v-show="isLoading" :size="70" :width="7" color="red" indeterminate></v-progress-circular>
    </v-flex>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { db } from '../main'
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
import PostButton from './common/PostButton'
const nens = ['平成元年', '平成2年', '平成3年', '平成4年', '平成5年', '平成6年', '平成7年', '平成8年', '平成9年', '平成10年', '平成11年', '平成12年', '平成13年', '平成14年', '平成15年', '平成16年', '平成17年', '平成18年', '平成19年', '平成20年', '平成21年', '平成22年', '平成23年', '平成24年', '平成25年', '平成26年', '平成27年', '平成28年', '平成29年', '平成30年', '平成31年', '令和元年', '令和2年']
export default {
  name: 'View',
  data () {
    return {
      limit: 20,
      lastObj: undefined,
      type: 'latest',
      records: [],
      isLoading: false,
      isMax: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    }
  },
  head: {
    title: function () {
      return {
        inner: 'TwitterBot管理用',
        separator: '|',
        complement: '平成年表'
      }
    },
    meta: function () {
      return [
        {name: 'robots', content: 'noindex'}
      ]
    }
  },
  filters: {
    textTrim: function (value) {
      let max = 30
      if (value.length >= 30) return value.substring(0, max - 1) + '...'
      return value
    },
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    }
  },
  created () {
    this.refresh()
  },
  methods: {
    refresh () {
      this.isLoading = true
      let dbRef = db.collection('chronology').where('release', '==', true)
      if (this.type === 'latest') {
        dbRef = dbRef.orderBy('timestamp', 'desc')
      } else if (this.type === 'popularity') {
        dbRef = dbRef.orderBy('comment_count', 'desc')
      }
      if (this.lastObj !== undefined) {
        dbRef = dbRef.startAfter(this.lastObj)
      }
      dbRef.limit(this.limit).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          // サムネイル画像の設定
          if (obj.image) {
            let fname = `chronology/${doc.id}/${obj.image}`
            let encodeFname = encodeURIComponent(fname)
            let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
            obj.imageUrl = imageUrl
          } else {
            obj.imageUrl = 'https://www.katsulabo.com/heisei/image/icon2.png'
          }
          // 説明文の設定
          if (obj.introduction !== undefined && obj.introduction.length > 1) {
            obj.text = obj.introduction
          } else {
            obj.text = obj.message
          }
          this.records.push(obj)
        })
        if (snapshot.docs.length === this.limit) {
          this.lastObj = snapshot.docs[snapshot.docs.length - 1]
          this.isMax = false
        } else {
          this.isMax = true
        }
        this.isLoading = false
      })
    },
    onTabClick (tab) {
      if (this.type === tab) return
      this.type = tab
      this.lastObj = undefined
      this.records = []
      this.isMax = false
      this.refresh()
    },
    onMore () {
      this.refresh()
    },
    onRecordClick (id) {
      this.$router.push({name: 'Chronology', params: {id: id}})
    },
    setTwitter (obj) {
      var batch = db.batch()
      var twiRef = db.collection('twitter')
      var nenpyoName = obj.title
      var nenpyoId = obj.id
      db.collection('chronology').doc(obj.id).collection('tips').get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let tip = doc.data()
          let message = `${nens[tip.year]}\r\n${tip.title}\r\n\r\n${nenpyoName}の年表\r\n\r\n#平成 #平成年表 #平成最後\r\nhttps://heisei.me/c/${nenpyoId}`
          let obj = {
            message: message,
            year: tip.year,
            title: nenpyoName,
            posted: false
          }
          if (tip.image) {
            let fname = `chronology/${nenpyoId}/${tip.image}`
            let encodeFname = encodeURIComponent(fname)
            let imageurl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
            obj.imageurl = imageurl
          }
          batch.set(twiRef.doc(doc.id), obj)
        })
        batch.commit().then(() => {
          alert('成功')
        })
      })
    },
    getTwitter () {
      db.collection('twitter').where('posted', '==', false).orderBy('year', 'asc').limit(1).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          console.log(doc.data())
        })
      })
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    PostButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
.block{
  margin-top: 24px;
  width: 100%;
  text-align:center;
}
.block-top{
  margin-top: 10%;
  margin-bottom: 10%;
  width: 100%;
}
.block-subtitle {
  padding:0 20px;
  margin:0 auto;
  margin-bottom:10px;
}
.v-list__tile__title {
  height: 30px !important;
  padding-top: 4px;
}
.record-wrapper{
  padding-bottom:10px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #bbb;
}
.v-list__tile__avatar {
  min-width:76px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TwitterView.vue